@if (show) {
  <div data-cy="consult-accept-efektika-draft-strategy" class="modal-content-container">
    <div>
      <p>{{ 'modal.efektikaClientAccept.item1' | translate }}</p>
      <p>{{ 'modal.efektikaClientAccept.item2' | translate }}</p>
      <p>{{ 'modal.efektikaClientAccept.item3' | translate }}</p>
      <div class="link-wrapper">
        {{ 'modal.efektikaClientAccept.item4' | translate }}
        <div class="document-link"
          (click)="efektikaPdfDownloadService.downloadEfektikaPdf()"
          (keydown.space)="efektikaPdfDownloadService.downloadEfektikaPdf()"
          (keydown.enter)="efektikaPdfDownloadService.downloadEfektikaPdf()"
          tabindex="0"
        >
          {{ 'modal.efektikaItemLink' | translate }}
        </div>
      </div>
      <p>{{ 'modal.efektikaClientAccept.item5' | translate }}</p>
    </div>
    <div class="action-buttons-container">
      <libero-button
        label="{{ 'global.buttons.createEfektikaStrategy' | translate }}"
        btnClasses="btn--primary btn--heading btn--s-20"
        (click)="onContinueBtnClick()"
        data-cy="client-accept-efektika-strategy-btn"
        [preloader]="!!loadingConfirm"
      ></libero-button>
      <libero-button
        label="{{ 'global.buttons.back' | translate }}"
        btnClasses="btn--secondary"
        (click)="onBackBtnClick()"
      ></libero-button>
    </div>
  </div>
}
